import * as React from 'react';
import { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Col, FormGroup, Label, Input } from 'reactstrap';
import FormComponent from './formComponent';

class HomeFormModalComponent extends Component {
    constructor(props) {
        super(props);
        // if this component is placed inside another modal, there will be a strange z-index issue, 
        // so we need to close the parent modal

        this.state = {
            modal: this.props.modal,
            formValues: {}
        }

        this.toggle = this.toggle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        if (this.props.toggleButtonId != null) {

            let triggerElement = document.getElementById(this.props.toggleButtonId);

            if (triggerElement != null) {
                triggerElement.onclick = this.toggle;
            }
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState(prevState => ({
            formValues: {
                ...prevState.formValues,
                [name]: value
            }
        }));
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    render() {

        let buttonId = this.props.form.formName + '_modal';
        return (
            <div className="banner-form">

                <FormGroup row key="nameGroup" className="label-top">
                    <Col sm={6}>
                        <Label for="banner_form_firstName"
                            className="input-label">
                            First Name
                        </Label>
                        <Input
                            id="banner_form_firstName"
                            type="text" name="FirstName"
                            onChange={this.handleInputChange}
                            placeholder="First Name"
                        />
                    </Col>
                    <Col sm={6}>
                        <Label for="banner_form_lastName"
                            className="input-label">
                            Last Name
                        </Label>
                        <Input
                            id="banner_form_lastName"
                            type="text" name="LastName"
                            onChange={this.handleInputChange}
                            placeholder="Last Name"
                        />
                    </Col>
                </FormGroup>

                <FormGroup row key="emailGroup" className="label-top">
                    <Col sm={12}>
                        <Label for="banner_form_email"
                            className="input-label">
                            Email
                        </Label>
                        <Input
                            id="banner_form_email"
                            type="email" name="Email"
                            onChange={this.handleInputChange}
                            placeholder="Email"
                        />
                    </Col>
                </FormGroup>

                <FormGroup row key="zipGroup" className="label-top">
                    <Col sm={6}>
                        <Label for="banner_form_zip"
                            className="input-label">
                            Delivery Zip Code
                        </Label>
                        <Input
                            id="banner_form_zip"
                            type="text" name="DeliveryZipCode"
                            onChange={this.handleInputChange}
                            placeholder="Zip Code"
                        />
                    </Col>
                    <Col sm={6} className="mt-auto">
                        <Button data-toggle={this.props.parentTargetModal ? 'modal' : ''}
                            data-target={this.props.parentTargetModal ? ('#' + this.props.parentTargetModal) : ''}
                            style={this.props.toggleButtonLabel && this.props.toggleButtonLabel !== "" ? {} : { display: 'none' }}
                            id={buttonId} color="primary" onClick={this.toggle}>
                            {this.props.toggleButtonLabel}
                        </Button>
                    </Col>
                </FormGroup>

                <Modal isOpen={this.state.modal}
                    toggle={this.toggle}
                    className={'modal-forms ' + (this.props.className || '')}
                    scrollable="true"
                    size="lg"
                >
                    <ModalHeader toggle={this.toggle}>
                        {this.props.headerSmallTitle && <div className="small-title" dangerouslySetInnerHTML={{ __html: this.props.headerSmallTitle }}></div>}
                        {this.props.headerTitle && <div className="title" dangerouslySetInnerHTML={{ __html: this.props.headerTitle }}></div>}
                    </ModalHeader>
                    <ModalBody>
                        <FormComponent
                            gooleRecaptchaSitekey={this.props.form.gooleRecaptchaSitekey}
                            apiEndpoint={this.props.form.apiEndpoint}
                            formName={this.props.form.formName}
                            defaultValues={this.state.formValues}
                            culture={this.props.form.culture}
                            siteName={this.props.form.siteName}
                            showLabels={this.props.form.showLabels}
                            labelsOnTop={this.props.form.labelsOnTop}
                            inModal
                        />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default HomeFormModalComponent;